import { connect } from "react-redux";
// API
import api from "api";
// Component
import CustomerAdminModal from "components/CustomerDetail/CustomerAdminModal";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
import { showSnackbar } from "redux/modules/snackbar";
import {
  changeCustomerAdminModalForm,
  setCustomerAdminModalError,
  closeCustomerAdminModal
} from "redux/modules/customerDetail";
// Utils
import history from "utils/history";

const mapStateToProps = state => {
  const { modal } = state.customerDetail.customerAdminCard;
  const { customerAdmin } = modal;

  const action = customerAdmin.isNew() ? "new" : "edit";
  const title = customerAdmin.isNew() ? "担当者登録" : "担当者編集";
  const btnLabel = customerAdmin.isNew() ? "登録" : "更新";

  return {
    ...modal,
    action,
    title,
    btnLabel
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  changeForm: (key, value) => {
    dispatch(changeCustomerAdminModalForm(key, value));
  },
  // 登録
  handleCreate: customerAdmin => {
    const errors = customerAdmin.validation();
    if (errors.length > 0) {
      dispatch(setCustomerAdminModalError(errors));
      return;
    }

    const params = {
      customerAdmin: customerAdmin.toJS()
    };
    const dialogData = {
      title: "確認",
      contentText: "担当者を登録します。よろしいですか？",
      btnLabel: "登録",
      handleClick: () => {
        api
          .post(`customer_admins`, params)
          .then(res => {
            dispatch(closeConfirmDialog());

            if (res.errors) {
              dispatch(setCustomerAdminModalError(res.errors));
            } else {
              dispatch(closeCustomerAdminModal());
              dispatch(showSnackbar("担当者を登録しました。"));
              ownProps.fetchCustomerDetail();
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };

    dispatch(setCustomerAdminModalError([]));
    dispatch(openConfirmDialog(dialogData));
  },
  // 更新
  handleUpdate: customerAdmin => {
    const errors = customerAdmin.validation();
    if (errors.length > 0) {
      dispatch(setCustomerAdminModalError(errors));
      return;
    }

    const params = {
      customerAdmin: customerAdmin.toJS()
    };
    const dialogData = {
      title: "確認",
      contentText: "担当者を更新します。よろしいですか？",
      btnLabel: "更新",
      handleClick: () => {
        api
          .patch(`customer_admins/${customerAdmin.get("id")}`, params)
          .then(res => {
            dispatch(closeConfirmDialog());

            if (res.errors) {
              dispatch(setCustomerAdminModalError(res.errors));
            } else {
              dispatch(closeCustomerAdminModal());
              dispatch(showSnackbar("担当者を更新しました。"));
              ownProps.fetchCustomerDetail();
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };

    dispatch(setCustomerAdminModalError([]));
    dispatch(openConfirmDialog(dialogData));
  },
  handleClose: () => {
    dispatch(closeCustomerAdminModal());
  },
  handleDelete: customerAdmin => {
    const dialogData = {
      title: "確認",
      contentText: "担当者を削除します。よろしいですか？",
      btnLabel: "削除",
      caution: true,
      handleClick: () => {
        api
          .delete(`customer_admins/${customerAdmin.get("id")}`)
          .then(res => {
            dispatch(closeConfirmDialog());

            if (res.errors) {
              dispatch(setCustomerAdminModalError(res.errors));
            } else {
              dispatch(closeCustomerAdminModal());
              dispatch(showSnackbar("担当者を削除しました。"));
              ownProps.fetchCustomerDetail();
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };

    dispatch(setCustomerAdminModalError([]));
    dispatch(openConfirmDialog(dialogData));
  },
  handlePasswordReset: customerAdmin => {
    const dialogData = {
      title: "確認",
      contentText:
        "パスワードをリセットします。新しいパスワードは担当者宛てにメールで送信されます。よろしいですか？",
      btnLabel: "送信",
      handleClick: () => {
        api
          .patch(`customer_admins/${customerAdmin.get("id")}/password_reset`)
          .then(res => {
            dispatch(closeConfirmDialog());

            if (res.errors) {
              dispatch(setCustomerAdminModalError(res.errors));
            } else {
              dispatch(
                showSnackbar("新しいパスワードを担当者宛てに送信しました。")
              );
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };

    dispatch(setCustomerAdminModalError([]));
    dispatch(openConfirmDialog(dialogData));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerAdminModal);



// WEBPACK FOOTER //
// ./src/containers/CustomerDetail/CustomerAdminModalContainer.js